import { CDK_ROW_TEMPLATE, CdkFooterRow, CdkHeaderRow, CdkRow, CdkCellOutlet } from '@angular/cdk/table';
import { ChangeDetectionStrategy, Component, HostBinding, ViewEncapsulation } from '@angular/core';

/**
 * @ngdoc component
 * @name ApHeaderRowComponent
 * @module ApTableModule
 * @description
 * Header template container that contains the cell outlet. Adds the right class.
 */
@Component({
    selector: 'ap-header-row, tr[ap-header-row]',
    template: CDK_ROW_TEMPLATE,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    exportAs: 'apHeaderRow',
    providers: [{ provide: CdkHeaderRow, useExisting: ApHeaderRowComponent }],
    imports: [CdkCellOutlet]
})
export class ApHeaderRowComponent extends CdkHeaderRow {
    @HostBinding('class.ap-header-row') apHeaderRow = true;
}

/**
 * @ngdoc component
 * @name ApFooterRowComponent
 * @module ApTableModule
 * @description
 * Header template container that contains the cell outlet. Adds the right class.
 */
@Component({
    selector: 'ap-footer-row, tr[ap-footer-row]',
    template: CDK_ROW_TEMPLATE,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    exportAs: 'apFooterRow',
    providers: [{ provide: CdkFooterRow, useExisting: ApFooterRowComponent }],
    imports: [CdkCellOutlet]
})
export class ApFooterRowComponent extends CdkFooterRow {
    @HostBinding('class.ap-footer-row') apFooterRow = true;
}

/**
 * @ngdoc component
 * @name ApRowComponent
 * @module ApTableModule
 * @description
 * Data row template container that contains the cell outlet. Adds the right class.
 */
@Component({
    selector: 'ap-row, tr[ap-row]',
    template: CDK_ROW_TEMPLATE,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    exportAs: 'apRow',
    providers: [{ provide: CdkRow, useExisting: ApRowComponent }],
    imports: [CdkCellOutlet]
})
export class ApRowComponent extends CdkRow {
    @HostBinding('class.ap-row') apRow = true;
}

/**
 * @ngdoc component
 * @name ApSubTableRowComponent
 * @module ApTableModule
 * @description
 * Data row template container that contains the cell outlet. Specifically designed for rows within a table with subrows. Adds the right class.
 */
@Component({
    selector: 'ap-subtable-row, tr[ap-subtable-row]',
    template: CDK_ROW_TEMPLATE,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    exportAs: 'apSubTableRow',
    providers: [{ provide: CdkRow, useExisting: ApRowComponent }],
    imports: [CdkCellOutlet]
})
export class ApSubTableRowComponent extends ApRowComponent {
    @HostBinding('class.ap-subTableRow') subTableRow = true;
}
